import { render, staticRenderFns } from "./PurchaseTransactions.vue?vue&type=template&id=6b44b144&"
import script from "./PurchaseTransactions.vue?vue&type=script&lang=js&"
export * from "./PurchaseTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports